import { openMetadataApiClient } from '@/shared/api/core/axios-instance';

type DeleteDomainRequest = {
  domainId: string;
  recursive?: boolean;
  hardDelete?: boolean;
};

export const deleteDomainApi = async (request: DeleteDomainRequest): Promise<void> => {
  const { domainId, recursive = true, hardDelete = true } = request;
  await openMetadataApiClient.delete(`/domains/${domainId}`, {
    params: {
      recursive,
      hardDelete,
    },
  });
};

export type { DeleteDomainRequest };
